__turbopack_context__.v({
  "blok-big-title": "ColumnsBlok-module__C7bsCa__blok-big-title",
  "blok-subtitle": "ColumnsBlok-module__C7bsCa__blok-subtitle",
  "blok-title": "ColumnsBlok-module__C7bsCa__blok-title",
  "left": "ColumnsBlok-module__C7bsCa__left",
  "right": "ColumnsBlok-module__C7bsCa__right",
  "root": "ColumnsBlok-module__C7bsCa__root",
  "y_offset_override": "ColumnsBlok-module__C7bsCa__y_offset_override",
});
